import React from "react";
import "../styles/whyGyde.css";

const WhyGyde = () => {
  return (
    <section className="why-gyde-section">
      <h1 className="why-bg-title">The Mission & Vision</h1>

      <div className="why-content">
        <h2>Why We Gyde?</h2>

        <p>
          Expert guidance is one of the most powerful tools for improving human
          <br />
          movement — but it remains inaccessible to millions due to cost,
          availability, and
          <br />
          scalability.
        </p>

        <p className="why-highlight">
          Through Gyde we envision to bridge this gap of expert movement
          coaching by
          <br />
          transforming every smartphone into an intelligent-coach.
        </p>
      </div>
    </section>
  );
};

export default WhyGyde;
